import React from "react";
import EntryOptions from "../../components/DataEntryOptions";

const ServicesMatrixOptions = () => (
  <EntryOptions label="Enter Services Data" action="services" />
);

export default ServicesMatrixOptions;
